async function loginUser(credentials, setError, setUser) {
  try {
    const baseUrl = (process.env.REACT_APP_SERVER || "").replace(/\/$/, "");
    const url = baseUrl + '/api/auth/signin';
    
    console.log("Requesting login from:", url);

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(credentials)
    });

    const contentType = response.headers.get("content-type");
    let data;
    if (contentType && contentType.indexOf("application/json") !== -1) {
      data = await response.json();
    } else {
      const text = await response.text();
      console.error("Non-JSON response from " + url + ":", text);
      return setError("Server error: " + response.statusText);
    }

    if (response.ok) {
      if (data.accessToken) {
        setUser(data);
      } else {
        setError(data.message || "Login failed");
      }
    } else {
      setError(data.message || "Server returned an error (" + response.status + ")");
    }
  } catch (error) {
    console.error("Login fetch error:", error);
    setError("Network error: check your connection and API URL.");
  }
}

function logOut(){
    localStorage.removeItem("token");
    window.location.reload(false);
}

module.exports = {loginUser, logOut}